// Shared translations for the admin platform-logs table labels.
// Consumers: mQmarketing (AdminPlatformLogsSection), mQguard (AdminPage),
// my-vitalteam (AdminPlatformLogsPage).
//
// These 9 keys live in their OWN file (not in adminTranslations.ts) because
// adminTranslations.ts only carries de/en/ru, while my-vitalteam also needs uk/it
// and does NOT merge sharedAdmin at all. Keeping them here in all five languages
// lets my-vitalteam pick up the shared coverage, and prevents these keys from being
// duplicated across two shared objects that the same app merges.
//
// German normalization: adjectives/pronouns lowercase, nouns capitalized
// (e.g. "alle Schweregrade", "Logeintrag löschen").

export const sharedAdminPlatformLogDe = {
  "Date": "Datum",
  "Source": "Quelle",
  "Email account": "E-Mail-Konto",
  "Actions": "Aktionen",
  "All severities": "alle Schweregrade",
  "Info": "Info",
  "Warning": "Warnung",
  "Error": "Fehler",
  "Delete log entry": "Protokolleintrag löschen",
  "Process": "Vorgang",
  "Project": "Projekt",
  "Copy technical details": "technische Details kopieren",
  "Technical details copied": "technische Details kopiert",
} as const;

export const sharedAdminPlatformLogEn = {
  "Date": "Date",
  "Source": "Source",
  "Email account": "Email account",
  "Actions": "Actions",
  "All severities": "All severities",
  "Info": "Info",
  "Warning": "Warning",
  "Error": "Error",
  "Delete log entry": "Delete log entry",
  "Process": "Process",
  "Project": "Project",
  "Copy technical details": "Copy technical details",
  "Technical details copied": "Technical details copied",
} as const;

export const sharedAdminPlatformLogRu = {
  "Date": "Дата",
  "Source": "Источник",
  "Email account": "Почтовый аккаунт",
  "Actions": "действия",
  "All severities": "все уровни",
  "Info": "Инфо",
  "Warning": "Предупреждение",
  "Error": "Ошибка",
  "Delete log entry": "удалить запись",
  "Process": "процесс",
  "Project": "проект",
  "Copy technical details": "копировать технические детали",
  "Technical details copied": "технические детали скопированы",
} as const;

export const sharedAdminPlatformLogUk = {
  "Date": "Дата",
  "Source": "Джерело",
  "Email account": "Поштовий акаунт",
  "Actions": "Дії",
  "All severities": "усі рівні",
  "Info": "Інфо",
  "Warning": "Попередження",
  "Error": "Помилка",
  "Delete log entry": "видалити запис",
  "Process": "процес",
  "Project": "проєкт",
  "Copy technical details": "копіювати технічні деталі",
  "Technical details copied": "технічні деталі скопійовано",
} as const;

export const sharedAdminPlatformLogIt = {
  "Date": "Data",
  "Source": "Origine",
  "Email account": "Account e-mail",
  "Actions": "Azioni",
  "All severities": "tutte le gravità",
  "Info": "Info",
  "Warning": "Avviso",
  "Error": "Errore",
  "Delete log entry": "elimina voce",
  "Process": "processo",
  "Project": "progetto",
  "Copy technical details": "copia dettagli tecnici",
  "Technical details copied": "dettagli tecnici copiati",
} as const;

export const sharedAdminPlatformLogTranslations = {
  de: sharedAdminPlatformLogDe,
  en: sharedAdminPlatformLogEn,
  ru: sharedAdminPlatformLogRu,
  uk: sharedAdminPlatformLogUk,
  it: sharedAdminPlatformLogIt,
} as const;

export type SharedAdminPlatformLogLang = keyof typeof sharedAdminPlatformLogTranslations;
export type SharedAdminPlatformLogKey = keyof typeof sharedAdminPlatformLogDe;
